const fromChannels = {
    IPAY: 'IPAY',
    SDB: 'SDB'
}

export default fromChannels